import {
  LOAD_SUCCESS_EQUIPEMENTS,
  LOAD_FAIL_EQUIPEMENTS,
  SAVE_SUCCESS_EQUIPEMENTS,
  SAVE_FAIL_EQUIPEMENTS,
  UPDATE_SUCCESS_EQUIPEMENTS,
  UPDATE_FAIL_EQUIPEMENTS,
  DELETE_SUCCESS_EQUIPEMENTS,
  DELETE_FAIL_EQUIPEMENTS,
} from "../actions/equipementAction";

const initialState = {
  loaded: false,
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case LOAD_SUCCESS_EQUIPEMENTS:
      return {
        ...state,
        loaded: true,
        data: action.payload,
        error: null,
      };
    case LOAD_FAIL_EQUIPEMENTS:
      return {
        ...state,
        loaded: false,
        data: null,
        error: action.error,
      };
    case SAVE_SUCCESS_EQUIPEMENTS:
      return {
        ...state,
        loading: false,
        loaded: true,
        data: [...state.data, action.payload],
        error: null,
      };
    case SAVE_FAIL_EQUIPEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case UPDATE_SUCCESS_EQUIPEMENTS:
      const updatedListe = [];

      state.data.forEach((item) => {
        if (item.equipement_id === action.payload.equipement_id) {
          item = action.payload;
        }
        updatedListe.push(item);
      });

      return {
        ...state,
        loading: false,
        loaded: true,
        data: updatedListe,
        error: null,
      };
    case UPDATE_FAIL_EQUIPEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    case DELETE_SUCCESS_EQUIPEMENTS:
      const filtered = state.data.filter((item) => {
        return item.equipement_id !== action.id;
      });
      return {
        ...state,
        loading: false,
        loaded: true,
        data: filtered,
        error: null,
      };
    case DELETE_FAIL_EQUIPEMENTS:
      return {
        ...state,
        loading: false,
        loaded: false,
        data: state.data,
        error: action.error,
      };
    default:
      return state;
  }
}
